import { useWatch } from 'react-hook-form'
import { StudentObervationCard } from '@/components/cards/student-observation'
import type { StudentRequestedCoursesFormMethods } from '@/types/forms/student-requested-courses-form-methods'
import { Modal } from '../modal'

interface GrantReviewModal {
  isOpen: boolean
  setOpen: (value: boolean) => void
  formMethods: StudentRequestedCoursesFormMethods
  grantIsPending: boolean
  grantSubmit?: () => void
}

export const GrantReviewModal = ({
  isOpen,
  setOpen,
  formMethods,
  grantIsPending,
  grantSubmit
}: GrantReviewModal) => {
  const watched = useWatch({
    control: formMethods.control,
    name: 'observation'
  })

  const disableSubmit = () => {
    if (watched) {
      if (watched.length !== 0) {
        return false
      }
    }

    return true
  }

  return (
    <Modal
      backButtonLabel="Cancelar"
      submitButtonLabel="Deferir"
      submitButtonclassName="bg-[var(--brand-green)]"
      submitButtonDisabled={disableSubmit()}
      title="Deferir Análise"
      isOpen={isOpen}
      description="Selecione um currículo disponível"
      pendingSubmit={grantIsPending}
      setOpen={setOpen}
      className="sm:max-w-none w-250"
      submitAction={grantSubmit}
    >
      <p className="text-[var(--brand-green)] font-bold">Deferimento</p>
      <p className="mt-5">
        Esta ação irá deferir a análise para o aluno.{' '}
        <strong>
          Não será mais possível reutilizar esta análise novamente.
        </strong>
      </p>
      <p className="mt-6">
        Para realizar o deferimento é necessário que você{' '}
        <strong>escreva uma observação para o aluno</strong> sobre as
        disciplinas, especificando possivelmente motivos de disciplinas negadas
        ou aprovadas.
      </p>

      <div className="mt-5">
        <StudentObervationCard
          formMethods={formMethods}
          description="Escreva para o aluno uma observação sobre o deferimento"
        />
      </div>
      <div className="mt-3 font-bold">
        Deseja realmente{' '}
        <span className="text-[var(--brand-green)]">deferir</span> a análise?
      </div>
    </Modal>
  )
}
